<template>
  <div>
    <div class="post mt-14 xl:mt-16">
      <h2
        class="font-title text-2xl lg:text-3xl font-bold text-ocean-900"
        v-html="titleHtml"
      />
      <hr class="border-ocean-200 mt-4" />
    </div>
    <vetster-education
      class="vetster-prose"
      @open-live-chat="$refs.livechatCta.openModal()"
    >
      <template #default="slotProps">
        <p>
          {{ $t('vetster-education.if-your-pet-is-experiencing-symptoms', { concern: concernLabel }) }}
        </p>
        <p>
          {{ $t('vetster-education.often-times-it-can-be-difficult-to-get-an-appointment') }}
        </p>
        <h3>
          {{ $t('vetster-education.heres-how-we-can-help') }}
        </h3>
        <ul class="w-full space-y-3 !ml-0 !ps-0 *:!ps-0">
          <li class="flex items-start space-x-5">
            <fa
              :icon="['fal', 'book']"
              class="fa-fw text-bubblegum-500 mt-1"
            />
            <span>
              {{ $t('vetster-education.knowledge-is-key', { concern: concernLabel }) }}
              <a
                :href="localizeLanguageUrl(`/pet-connection/${concernPath}`)"
                @click="slotProps.trackVetsterEducation($event, 'select_these_resources')"
              >
                {{ $t('vetster-education.these-resources') }}
              </a>
              {{ $t('vetster-education.to-better-understand-what-might-be-going-on-for-your-pet') }}
            </span>
          </li>
          <li class="flex items-start space-x-5">
            <fa
              :icon="['fal', 'message']"
              class="fa-fw text-bubblegum-500 mt-1"
            />
            <span>
              <a
                href="javascript:;"
                @click="slotProps.trackOpenLiveChat($event, 'select_chat')"
              >
                {{ $t('vetster-education.chat') }}
              </a>
              {{ $t('vetster-education.with-our-247-online-pet-care-team') }}
            </span>
          </li>
          <li class="flex items-start space-x-5">
            <fa
              :icon="['fal', 'calendar']"
              class="fa-fw text-bubblegum-500 mt-1"
            />
            <span>
              <a
                :href="guidedSearchUrl"
                @click="slotProps.trackVetsterEducation($event, 'select_book_online_vet')"
              >
                {{ $t('vetster-education.book-an-online-vet-appointment') }}
              </a>
              {{ $t('vetster-education.schedule-a-video-call-with-one-of-our-licensed') }}
            </span>
          </li>
          <li class="flex items-start space-x-5">
            <fa
              :icon="['fal', 'prescription']"
              class="fa-fw text-bubblegum-500 mt-1"
            />
            <span>
              {{ $t('vetster-education.get-the') }}
              <a
                v-if="showVetsterRx"
                :href="localizeUrl('/vetster-rx-online-pharmacy')"
                @click="slotProps.trackVetsterEducation($event, 'select_get_prescriptions')"
              >
                {{ $t('vetster-education.prescriptions') }}
              </a>
              <span
                v-else
                v-html="$t('vetster-education.prescriptions')"
              />
              {{ $t('vetster-education.your-pet-needs-to-feel-better') }}
            </span>
          </li>
          <li class="flex items-start space-x-5">
            <fa
              :icon="['fal', 'heart']"
              class="fa-fw text-bubblegum-500 mt-1"
            />
            <span>
              {{ $t('vetster-education.keep-your-peace-of-mind-intact-with') }}
              <a
                :href="localizeUrl('/plus')"
                @click="slotProps.trackVetsterEducation($event, 'select_continuous_care')"
              >
                {{ $t('vetster-education.continuous-care') }}
              </a>
              {{ $t('vetster-education.for-your-pet-through-vetster') }}
            </span>
          </li>
        </ul>
      </template>
    </vetster-education>
    <vetster-livechat-cta
      ref="livechatCta"
      :show-button="false"
      class="w-full"
    >
      <template #store-icons>
        <div class="mt-6 flex justify-center-items-center">
          <div class="flex flex-1 flex-col space-y-2 w-full justify-center items-center sm:items-end pr-1">
            <vetster-mobile-app-buttons
              button-size="w-32"
              :apple-app-store-url="mobileApps.apple.url"
              :google-play-url="mobileApps.google.url"
            />
          </div>
          <div class="hidden sm:flex sm:flex-1 sm:pl-2">
            <img
              src="https://images.vetster.com/photos/livechat_qr_code.jpeg?ik-s=81d9166c8b7f0c8b03a8536700afdd184aaf5cc0"
              alt="app.mobile-app.livechat-qr-code"
              class="size-24"
            >
          </div>
        </div>
      </template>
    </vetster-livechat-cta>
  </div>
</template>

<script>
import VetsterEducation from '@/brand-components/VetsterEducation';
import VetsterLivechatCTA from '@/components/VetsterLivechatCTA';
import VetsterMobileAppButtons from '@/components/VetsterMobileAppButtons';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterPostEducation',

  components: {
    VetsterEducation,
    'vetster-livechat-cta': VetsterLivechatCTA,
    VetsterMobileAppButtons,
  },

  mixins: [LocalizesRoutes],

  props: {
    concern: {
      type: Object,
      required: true,
    },
    concernLabel: {
      type: String,
      required: true,
    },
    mobileApps: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    concernPath() {
      return this.concern.slug;
    },
    showVetsterRx() {
      return this.$statsig.ready && this.$statsig.checkGate('content_vetster_rx');
    },
    titleHtml() {
      return this.title?.replace('Vetster', '<span class="text-bubblegum-500">Vetster</span>');
    },
  },
};
</script>
